import { mapState } from 'vuex'
import filter from 'js/filter'
import {
  Achecksendmobliecode,
  Alogin
} from '@/service/app'
const MOBILE_REGEX = /^1[3-9]\d{9}$/;
const loginCommon = {
  data() {
    const _this = this
    return {
      loginNumber: {
        id: 1,
        mobileAreaCode: '86',
        countryName: '中国',
      },
      successCb: '',
      ruleValidate: {
        code: [{ required: true, message: filter.dealLanguage('请填写正确的验证码', 'Please fill in the correct verification code'), trigger: 'blur' }],
        mobileVerifyCode: [{ required: true, message: filter.dealLanguage('请填写正确的验证码', 'Please fill in the correct verification code'), trigger: 'blur' }],
        mobile: [
          { required: true, message: filter.dealLanguage('请输入您的手机号', 'Please enter your mobile number'), trigger: 'blur' },
          {
            type: 'number',
            message: filter.dealLanguage('手机号格式不正确', 'The phone number format is incorrect'),
            trigger: 'blur',
            transform(value) {
              if (_this.loginNumber.mobileAreaCode == '86')
                return MOBILE_REGEX.test(value) ? Number(value) : false
            },
          },
        ],
        email: [
          { required: true, message: filter.dealLanguage('请填写您的邮箱', 'Please enter your email address'), trigger: 'blur' },
          { type: 'email', message: filter.dealLanguage('请填写正确的邮箱', 'Please enter a valid email address.'), trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      index2_path: (state) => state.index2_path,
      index_path: (state) => state.index_path,
      img_req_url: (state) => state.img_req_url,
      isMobile: (state) => state.isMobile,
      appMobileAreaCodeDtos: (state) => state.appMobileAreaCodeDtos,
      loginWxAppId: (state) => state.loginWxAppId,
    }),

  },
  methods: {
    beginLogin(cb = '') {
      this.successCb = cb
      this.modelIndex = true
    },
    handleSubmit() {
      this.$refs['code-form'].validate(async (valid) => {
        if (valid) {
          let params = {
            ...{
              loginPlatform: this.isMobile ? 9 : 8,
              type: 2,
              mobileAreaCode: this.loginNumber.mobileAreaCode,
            },
            ...this.codeForm,
          }
          let res = await Alogin(params)
          if (res.code == 0) {
            this.loginSuccess(res.data)
          } else {
            if (this.isMobile) this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
            else this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
          }
        }
      })
    },
    updateRuleValidate() {
      let params = {}
      const baseRules = {
        code: [{ required: true, message: '请填写正确的验证码', trigger: 'blur' }]
      };

      if (this.loginNumber.mobileAreaCode == '86') {
        params = {
          ...baseRules,
          mobile: [
            { required: true, message: '请输入您的手机号', trigger: 'blur' },
            {
              type: 'number',
              message: '手机号格式不正确',
              trigger: 'blur',
              transform(value) {
                return MOBILE_REGEX.test(value) ? Number(value) : false;
              },
            },
          ],
        };
      } else {
        params = {
          ...baseRules,
          mobile: [
            { required: true, message: '请输入您的手机号', trigger: 'blur' },
          ],
        };
      }
      this.ruleValidate = {...params};
    },
    handleSubmitEn() {
      this.$refs['code-form'].validate(async (valid) => {
        if (valid) {
          let params = {
            ...{
              loginPlatform: this.isMobile ? 9 : 8,
              type: 11,
            },
            ...this.codeForm,
          }
          let res = await Alogin(params)
          if (res.code == 0) {
            this.loginSuccess(res.data)
          } else {
            if (this.isMobile) this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
            else this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
          }
        }
      })
    },
    /**
     * 第三方登录
     * 8领英登录，9谷歌登录，10苹果登录
     */
    async thirdPartyLogin(code, type) {
      const params = {
        code,
        type,
        loginPlatform: this.isMobile ? 9 : 8,
        redirectUrl: type === 8 ? `${this.vbef_path}/callback/linkedin` : ''
      }
      const res = await Alogin(params)
      if (res.code == 0) {
        this.loginSuccess(res.data)
      } else {
        if (this.isMobile) this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
        else this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
  },
}
export { loginCommon }
